import React from 'react';
import './footer.css';
import menuJson from './menuJson';
import socialJson from './contactJson';
import { Link } from 'react-scroll';

function Footer() {
    return (
        <section className='footerIndex'>
            <div className='flexIndex'>
                <div className='colIndex'>
                    <h3>INDEX®</h3>
                    <ol>
                        {menuJson.map((menues) => (
                            <li key={menues.idSearch}>
                                <a href={menues.idSearch} target="_self" rel="noopener noreferrer">
                                    {menues.titulo}
                                </a>
                            </li>
                        ))}
                    </ol>
                </div>
                <div className='colIndex'>
                    <h3>Socials</h3>
                    <ol>
                        {socialJson.map((menues, index) => (
                            <li key={menues.idSearch}>
                                <Link to={menues.idSearch} smooth={true} duration={500}>
                                    {menues.titulo}
                                </Link>
                            </li>
                        ))}
                    </ol>
                </div>
                <div className='colIndex'>
                    <h3>Legales</h3>
                    <ol>
                        <li><a href='/terminos'>Términos y Condiciones</a></li>
                        <li><a href='/seguridad'>Política de Seguridad y Privacidad</a></li>
                        <li><a href='/cookies'>Política de Cookies</a></li>
                    </ol>
                </div>
                
                <div className='colIndex'>
                    <p>Maure 2945 - CABA - Argentina</p>
                    <p>© 2024 Index®. All rights reserved.</p>
                </div>
            </div>
                    
                    
                    
                    <ol className='legalesMenu'>
                        <li><a href='/terminos'>Términos y Condiciones</a></li>
                        <li><a href='/seguridad'>Política de Seguridad y Privacidad</a></li>
                        <li><a href='/cookies'>Política de Cookies</a></li>
                    </ol>   
        </section>
    )
}

export default Footer;